import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { IMPACT_STORY } from "@/content/site";
import Reveal from "@/components/Reveal";
import ContextLine from "@/components/ContextLine";

export default function ImpactStory() {
  const count = IMPACT_STORY.sequence.length;
  return (
    <section data-testid="impact-story-section" className="bg-paper py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <Reveal>
          <span className="eyebrow mb-6">أثرنا</span>
          <h2 className="font-display text-navy leading-tight" style={{ fontSize: "clamp(1.5rem, 2.9vw, 2.5rem)" }}>
            قصة أثر: <span style={{ color: "var(--coral)" }}>{IMPACT_STORY.name}</span>
          </h2>
          <p className="mt-4 text-blue text-lg max-w-2xl leading-relaxed">
            لا نجعل الأرقام وحدها وجهتنا؛ نروي كيف تحوّل السياق إلى أثر ملموس ومستدام
          </p>
        </Reveal>

        {/* One continuous line threading the sequence + numbers */}
        <div className="relative mt-20">
          <ContextLine
            d="M0,50 C240,10 420,90 640,50 C860,10 1040,90 1200,50"
            viewBox="0 0 1200 100"
            className="absolute -top-4 inset-x-0 h-16 w-full pointer-events-none"
            strokeWidth={2.5}
            withDot
            duration={2.8}
          />

          <div className="relative grid gap-10 md:grid-cols-4">
            {IMPACT_STORY.sequence.map((step, i) => (
              <Reveal key={step.label} delay={i * 0.1}>
                {/* node stem hanging from the line */}
                <span className="block h-3 w-3 rounded-full mb-5" style={{ backgroundColor: i === count - 1 ? "var(--coral)" : "var(--peach)" }} aria-hidden="true" />
                <span className="text-sm font-semibold" style={{ color: "var(--purple)" }}>{`المرحلة ${i + 1}`}</span>
                <h3 className="mt-2 font-display text-navy text-xl">{step.label}</h3>
                <p className="mt-3 text-blue leading-relaxed text-[0.98rem]">{step.text}</p>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Numbers tied to the same line via copper stems */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-px bg-navy/10" data-testid="impact-stats">
          {IMPACT_STORY.stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1} className="bg-paper p-10 text-center border-t-2" >
              <div className="mx-auto mb-4 h-6 w-px" style={{ backgroundColor: "var(--coral)" }} aria-hidden="true" />
              <div className="font-display leading-none" style={{ fontSize: "clamp(2.1rem, 4vw, 3.2rem)", color: "var(--navy)" }}>
                {s.prefix}{s.value}{s.suffix}
              </div>
              <div className="mt-3 text-blue">{s.label}</div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12">
          <Link to="/impact#projects" data-testid="impact-story-cta" className="group inline-flex items-center gap-2 text-navy border border-navy/25 px-7 py-4 text-base font-medium hover:bg-navy hover:text-white transition-colors">
            اطّلع على مشاريعنا
            <ArrowLeft size={18} className="transition-transform group-hover:-translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
